import React from "react";
import { toast as baseToast } from "react-toastify";

const ToastMessage = ({ icon, message }) => (
  <div className="toast-message">
    <span className="Toastify__toast-icon">{icon}</span>
    <div className="toast-message__text">{message}</div>
  </div>
);

const SuccessIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M12.9993 23.8332C18.9824 23.8332 23.8327 18.9829 23.8327 12.9998C23.8327 7.01675 18.9824 2.1665 12.9993 2.1665C7.01626 2.1665 2.16602 7.01675 2.16602 12.9998C2.16602 18.9829 7.01626 23.8332 12.9993 23.8332Z" fill="#1AAA55" />
    <path d="M9.75 13.0002L11.9167 15.1668L16.25 10.8335" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M12.9993 23.8332C18.9824 23.8332 23.8327 18.9829 23.8327 12.9998C23.8327 7.01675 18.9824 2.1665 12.9993 2.1665C7.01626 2.1665 2.16602 7.01675 2.16602 12.9998C2.16602 18.9829 7.01626 23.8332 12.9993 23.8332Z" fill="#DB3B21" />
    <path d="M16.25 9.75L9.75 16.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.75 9.75L16.25 16.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const WarnIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M2.95303 21.4062C2.75442 21.4062 2.57386 21.3556 2.41136 21.2542C2.24886 21.1528 2.12248 21.0185 2.0322 20.8512C1.94192 20.684 1.89245 20.5034 1.88378 20.3095C1.87511 20.1157 1.92459 19.9262 2.0322 19.7412L12.053 1.98079C12.1614 1.79579 12.3015 1.65704 12.4734 1.56453C12.6453 1.47203 12.8211 1.42578 13.0009 1.42578C13.1808 1.42578 13.357 1.47203 13.5296 1.56453C13.7022 1.65704 13.842 1.79579 13.9489 1.98079L23.9697 19.7412C24.078 19.9262 24.1279 20.116 24.1192 20.3107C24.1105 20.5053 24.0607 20.6855 23.9697 20.8512C23.8787 21.017 23.7523 21.1513 23.5905 21.2542C23.4288 21.357 23.2482 21.4077 23.0489 21.4062H2.95303Z" fill="#FC9403" />
    <path d="M12.9961 8.8L13.0078 14.2305" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.9961 17.1992H13.0061" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M13 23.5C18.799 23.5 23.5 18.799 23.5 13C23.5 7.20101 18.799 2.5 13 2.5C7.20101 2.5 2.5 7.20101 2.5 13C2.5 18.799 7.20101 23.5 13 23.5Z" fill="#1F78D1" />
    <path d="M13 17.2V13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 8.7998H13.01" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const toast = Object.assign((msg, opts) => baseToast(msg, opts), {
  success: (msg, opts) =>
    baseToast.success(<ToastMessage icon={<SuccessIcon />} message={msg} />, opts),
  error: (msg, opts) =>
    baseToast.error(<ToastMessage icon={<ErrorIcon />} message={msg} />, opts),
  warn: (msg, opts) =>
    baseToast.warn(<ToastMessage icon={<WarnIcon />} message={msg} />, opts),
  warning: (msg, opts) =>
    baseToast.warn(<ToastMessage icon={<WarnIcon />} message={msg} />, opts),
  info: (msg, opts) =>
    baseToast.info(<ToastMessage icon={<InfoIcon />} message={msg} />, opts),
  danger: (msg, opts) =>
    baseToast.error(<ToastMessage icon={<ErrorIcon />} message={msg} />, opts),
  dismiss: baseToast.dismiss,
  isActive: baseToast.isActive,
  update: baseToast.update,
  clearWaitingQueue: baseToast.clearWaitingQueue,
  POSITION: baseToast.POSITION,
  TYPE: baseToast.TYPE,
});

export default toast;
